<div class="modal-header">
    <h2 class="modal-title">Service Charge</h2>
</div>
<div class="flex-fill d-flex flex-column">
    <div class="card">
        <div class="card-body">
            <dx-form validationGroup="serviceChargeValidationGroup">
                <dxi-item [label]="{ text: 'Service Charges' }">
                    <div *dxTemplate>
                        <dx-select-box [(value)]="serviceCharge.partServiceChargeId" [items]="serviceCharges" valueExpr="id" displayExpr="name"></dx-select-box>
                    </div>
                    <dxi-validation-rule type="required"> </dxi-validation-rule>
                </dxi-item>
                <dxi-item [label]="{ text: 'Cost' }">
                    <div *dxTemplate>
                        <dx-number-box [(value)]="serviceCharge.cost" [format]="{ type: 'currency', precision: 5 }"> </dx-number-box>
                    </div>
                    <dxi-validation-rule type="required"> </dxi-validation-rule>
                </dxi-item>
            </dx-form>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="save()">Save</button>
    <button type="button" class="btn btn-success" (click)="close()">Close</button>
</div>
